export default function (currencies, search = '') {
  return search
    ? currencies.filter(
        (c) =>
          c.cur.name.toLowerCase().includes(search.toLowerCase()) ||
          c.cur.code.toLowerCase().includes(search.toLowerCase())
      )
    : currencies;
}
